"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PAYMENT_METHODS = exports.PAYMENT_DROPDOWN_OPTIONS = void 0;
let PAYMENT_METHODS = exports.PAYMENT_METHODS = /*#__PURE__*/function (PAYMENT_METHODS) {
  PAYMENT_METHODS["CREDIT_CARD"] = "credit_card";
  PAYMENT_METHODS["CASH"] = "cash";
  PAYMENT_METHODS["CHECK"] = "check";
  return PAYMENT_METHODS;
}({});
const PAYMENT_DROPDOWN_OPTIONS = exports.PAYMENT_DROPDOWN_OPTIONS = [{
  id: PAYMENT_METHODS.CREDIT_CARD,
  label: 'Credit or Debit Card'
}, {
  id: PAYMENT_METHODS.CASH,
  label: 'Cash'
}, {
  id: PAYMENT_METHODS.CHECK,
  label: 'Check'
}];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJQQVlNRU5UX01FVEhPRFMiLCJleHBvcnRzIiwiUEFZTUVOVF9EUk9QRE9XTl9PUFRJT05TIiwiaWQiLCJDUkVESVRfQ0FSRCIsImxhYmVsIiwiQ0FTSCIsIkNIRUNLIl0sInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvQWNjZXB0Q2hlY2svY29uc3RhbnRzLnRzIl0sInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBlbnVtIFBBWU1FTlRfTUVUSE9EUyB7XG4gIENSRURJVF9DQVJEID0gJ2NyZWRpdF9jYXJkJyxcbiAgQ0FTSCA9ICdjYXNoJyxcbiAgQ0hFQ0sgPSAnY2hlY2snLFxufVxuXG5leHBvcnQgY29uc3QgUEFZTUVOVF9EUk9QRE9XTl9PUFRJT05TID0gW1xuICB7IGlkOiBQQVlNRU5UX01FVEhPRFMuQ1JFRElUX0NBUkQsIGxhYmVsOiAnQ3JlZGl0IG9yIERlYml0IENhcmQnIH0sXG4gIHsgaWQ6IFBBWU1FTlRfTUVUSE9EUy5DQVNILCBsYWJlbDogJ0Nhc2gnIH0sXG4gIHsgaWQ6IFBBWU1FTlRfTUVUSE9EUy5DSEVDSywgbGFiZWw6ICdDaGVjaycgfSxcbl07XG4iXSwibWFwcGluZ3MiOiI7Ozs7OztJQUFZQSxlQUFlLEdBQUFDLE9BQUEsQ0FBQUQsZUFBQSwwQkFBZkEsZUFBZTtFQUFmQSxlQUFlO0VBQWZBLGVBQWU7RUFBZkEsZUFBZTtFQUFBLE9BQWZBLGVBQWU7QUFBQTtBQU1wQixNQUFNRSx3QkFBd0IsR0FBQUQsT0FBQSxDQUFBQyx3QkFBQSxHQUFHLENBQ3RDO0VBQUVDLEVBQUUsRUFBRUgsZUFBZSxDQUFDSSxXQUFXO0VBQUVDLEtBQUssRUFBRTtBQUF1QixDQUFDLEVBQ2xFO0VBQUVGLEVBQUUsRUFBRUgsZUFBZSxDQUFDTSxJQUFJO0VBQUVELEtBQUssRUFBRTtBQUFPLENBQUMsRUFDM0M7RUFBRUYsRUFBRSxFQUFFSCxlQUFlLENBQUNPLEtBQUs7RUFBRUYsS0FBSyxFQUFFO0FBQVEsQ0FBQyxDQUM5QyIsImlnbm9yZUxpc3QiOltdfQ==